const searchUrl = window.routes.search_url;
var RecomandationArticle = class extends HTMLElement {
    async connectedCallback() {
        if (this.searchQueryString !== "") {
            const response = await fetch(`${searchUrl}?type=product&q=${this.searchQueryString}&section_id=${this.sectionId}`);
            const div = document.createElement("div");
            div.innerHTML = await response.text();
            const productsElement = div.querySelector("recomendation-article");
            if (productsElement.hasChildNodes()) {
                this.innerHTML = productsElement.innerHTML;
            }
        }
        if (!this.querySelector(".swiper-slide")) {
            this.classList.add("hidden");
        }
        new Swiper(`.swiper-article-related-products-${this.sectionId}`, {
            slidesPerView: 2,
            spaceBetween: 10,
            navigation: {
                nextEl: `.swiper-button-next-${this.sectionId}`,
                prevEl: `.swiper-button-prev-${this.sectionId}`,
            },
            breakpoints: {
                // when window width is >= 480px
                480: {
                    slidesPerView: 3,
                    spaceBetween: 10
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 3,
                    spaceBetween: 10
                },
                990: {
                    slidesPerView: 4,
                    spaceBetween: 18
                }
            }
        });
    }
    get searchQueryString() {
        return this.getAttribute("search-query");
    }
    get sectionId() {
        return this.getAttribute("section-id");
    }
};
window.customElements.define("recomendation-article", RecomandationArticle);